﻿export const formatCurrency = (value, addCurrency = false) => {
  const country = document.querySelector('html').getAttribute('country');
  let countryCode = '', currency = '';

	if (country === 'se')
		countryCode = 'sv-SE', currency = 'SEK';
	else if (country === 'no')
		countryCode = 'nn-NO', currency = 'NOK'; //'nb-NO' = Bokmål
	else if (country === 'fi')
		countryCode = 'fi-FI', currency = 'EUR';

  let returnValue = new Intl.NumberFormat(
    countryCode, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
    })
    .format(value)
    .replace(' €', '')
    .replace(' kr', '')
    .replace(' Nkr', '')
    .replace('NOK\xa0', '')
    .replace('\xa0', '\u202F')

    if (addCurrency)
      returnValue = returnValue + ' ' + currency;

  return returnValue;
};
